export default {
      id: "experience-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#experience-usage",
      toString: function () {
        return this.url;
      }
    }